import { Check, Close } from '@mui/icons-material';
import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { PanelColumn } from './PanelColumn';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
};

export const PanelProsAndCons = ({ prosList, consList }: Props) => {
  const hasPros = !!prosList?.length;
  const hasCons = !!consList?.length;

  if (!hasPros && !hasCons) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
      }}
    >
      {hasPros && (
        <PanelColumn
          title="Pros"
          items={prosList}
          borderColor="greens.lighter"
          headerTextColor="greens.dark"
          headerBgColor="greens.lightest"
          iconChipBgColor="greens.lightest"
          Icon={Check}
          iconColor="success"
        />
      )}

      {hasCons && (
        <PanelColumn
          title="Cons"
          items={consList}
          borderColor="reds.lighter2"
          headerTextColor="reds.dark"
          headerBgColor="reds.lightest"
          iconChipBgColor="reds.lightest"
          Icon={Close}
          iconColor="error"
        />
      )}
    </Box>
  );
};
